import { render, staticRenderFns } from "./UserGeoStats.vue?vue&type=template&id=f685a5ee"
import script from "./UserGeoStats.vue?vue&type=script&lang=js"
export * from "./UserGeoStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports